import { Link } from 'react-router-dom';
import { CATEGORY_ORDER, PILLAR_TAGLINE } from '../../lib/briefModel.js';
import { CategoryIcon } from './categoryIcons.jsx';

function archiveHref(category) {
  return `/archive?category=${encodeURIComponent(category)}`;
}

export default function HomeCategories() {
  return (
    <section
      className="bg-black border-t border-[#262626]"
      aria-labelledby="home-categories-heading"
    >
      <div className="max-w-page mx-auto px-4 sm:px-6 py-12 sm:py-16">
      <header className="text-center max-w-2xl mx-auto mb-8 sm:mb-10">
        <h2
          id="home-categories-heading"
          className="font-sans text-[clamp(1.25rem,2.5vw,1.75rem)] font-bold leading-snug text-white m-0"
        >
          Stay ahead with focused intelligence
        </h2>
        <p className="text-[15px] sm:text-[16px] leading-relaxed text-[#A3A3A3] mt-3 m-0 max-w-xl mx-auto">
          Aerospace, AAM, defense, infrastructure, capital, and innovation — tracked across five
          pillars every morning.
        </p>
      </header>

      <ul className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-x-8 sm:gap-x-10 gap-y-10 sm:gap-y-12 max-w-[1100px] mx-auto list-none m-0 p-0">
        {CATEGORY_ORDER.map((cat, index) => {
          const isFifthAlone =
            index === CATEGORY_ORDER.length - 1 && CATEGORY_ORDER.length % 2 === 1;
          return (
            <li
              key={cat}
              className={
                isFifthAlone ? 'sm:col-span-2 sm:flex sm:justify-center xl:col-span-1 xl:block' : undefined
              }
            >
              <Link
                to={archiveHref(cat)}
                className={[
                  'home-category-tile group flex flex-col items-center text-center no-underline text-inherit',
                  'w-full max-w-[280px] px-1 py-1',
                  'transition-colors duration-200',
                  'hover:text-hxd-orange',
                  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-hxd-orange focus-visible:ring-offset-2 focus-visible:ring-offset-black rounded-sm',
                  'mx-auto',
                ]
                  .filter(Boolean)
                  .join(' ')}
              >
                <CategoryIcon
                  category={cat}
                  className="text-hxd-orange mb-4 group-hover:text-[#d94e1a]"
                />

                <h3 className="font-sans text-[16px] sm:text-[17px] font-bold text-white m-0 leading-snug group-hover:text-hxd-orange transition-colors duration-200">
                  {cat}
                </h3>

                <p className="text-[14px] leading-relaxed text-[#A3A3A3] mt-2 m-0 max-w-[280px] group-hover:text-[#D4D4D4] transition-colors duration-200">
                  {PILLAR_TAGLINE[cat]}
                </p>
              </Link>
            </li>
          );
        })}
      </ul>
      </div>
    </section>
  );
}
